import styled from 'styled-components';
import React, { useState } from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Shop } from '../../../../types/Feature';
import { useScheduledFeatureContext } from '../ScheduledFeatureContext';
import ConfirmDeleteTooltip from './ConfirmDeleteTooltip';

const TableRow = styled.tr``;

const DeleteIcon = styled.div`
    display: none;
    cursor: pointer;
    width: 8px;

    ${TableRow}:hover & {
        display: table-cell;
        width: 8px;
    }
`;

// eslint-disable-next-line react/display-name
export const ShopRow = React.memo(({ index, shop, isEditable }: { index: number; shop: Shop; isEditable: boolean }) => {
    const { handleFieldUpdate, deleteShop } = useScheduledFeatureContext();
    const [showTooltip, setShowTooltip] = useState(false);

    const handleDeleteShop = () => {
        deleteShop(index);
        setShowTooltip(false);
    };

    return (
        <TableRow>
            <td>
                <div style={{ position: 'relative' }}>
                    <DeleteIcon onClick={() => setShowTooltip(true)}>
                        <CloseCircleOutlined style={{ fontSize: '12px', color: 'red' }} />
                    </DeleteIcon>
                    {showTooltip && isEditable && (
                        <ConfirmDeleteTooltip onYesClick={handleDeleteShop} onNoClick={() => setShowTooltip(false)} />
                    )}
                </div>
            </td>
            <td>
                <EditableCell
                    isEditable={isEditable}
                    value={shop.address}
                    onValueUpdate={(value: any) => handleFieldUpdate(index, 'address', value)}
                />
            </td>
            <td>
                <EditableCell
                    isEditable={isEditable}
                    value={shop.assignment_code}
                    onValueUpdate={(value: any) => handleFieldUpdate(index, 'assignment_code', value)}
                />
            </td>
            <td>
                <EditableCell
                    isEditable={isEditable}
                    value={shop.enabled}
                    onValueUpdate={(value: any) => handleFieldUpdate(index, 'enabled', value)}
                />
            </td>
        </TableRow>
    );
});

const StyledCell = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ccc;
    padding: 8px;
    height: 100%;
`;

const StyledInput = styled.input`
    width: 100%;
    border: none;
    margin: 0;
    padding: 0;
    height: 32px;
    line-height: normal;

    &:focus {
        outline: none;
    }
`;

const EditableCell = ({
    value,
    isEditable,
    onValueUpdate,
}: {
    value: any;
    onValueUpdate: (value: any) => void;
    isEditable: boolean;
}) => {
    const handleInputChange = (event: any) => {
        const newValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        onValueUpdate(newValue);
    };

    return (
        <StyledCell>
            <StyledInput
                type={typeof value === 'boolean' ? 'checkbox' : 'text'}
                checked={typeof value === 'boolean' && value}
                value={value}
                onChange={handleInputChange}
                disabled={!isEditable}
            />
        </StyledCell>
    );
};
